/* Figma 3247:574：只管理展示状态，不写购物车、不重新计算商品/折扣/保障费。
 * .cart_Total 保留为现有摘要恢复/金额更新的商品金额来源；可见 Total 复用已校验的
 * data-checkout-total，因而包含已选择的保障费，也跟随现有换汇通道更新。
 */
(function () {
  if (window.CartPresentation) return;
  const open = new Map();
  const observed = new WeakSet();
  let scheduled = false;

  function copyMoney(source, target) {
    if (!source || !target || source.textContent.trim() === target.textContent.trim()) return;
    target.replaceChildren(...[...source.childNodes].map(node => node.cloneNode(true)));
  }

  function render() {
    document.querySelectorAll('[data-cart-summary]').forEach(root => {
      const scope = root.closest('#CartDrawer, #main-cart-footer');
      if (!scope) return;
      const button = root.querySelector('[data-cart-summary-toggle]');
      const panel = button && root.querySelector('#' + button.getAttribute('aria-controls').split(' ')[0]);
      const checkout = scope.querySelector('[data-checkout-total]');
      copyMoney(checkout, root.querySelector('[data-cart-summary-payable]'));
      const card = [...scope.querySelectorAll('#xcottonWrapper')]
        .find(node => getComputedStyle(node).display !== 'none');
      const selected = card && !!card.querySelector('.switch_btn.checked, #xcotton-switch.checked');
      const fee = root.querySelector('[data-cart-summary-protection]');
      const cardPrice = card && card.querySelector('.xcotton_price');
      const hasProtection = selected && !!cardPrice && !!cardPrice.textContent.trim();
      const hasDiscounts = panel && [...panel.querySelectorAll('li')]
        .some(row => !row.hidden && getComputedStyle(row).display !== 'none');
      const hasDetails = !!(hasDiscounts || hasProtection);
      if (!hasDetails) open.set(root.dataset.cartSummary, false);
      const expanded = hasDetails && open.get(root.dataset.cartSummary) === true;
      if (button && panel) {
        if (button.hidden !== !hasDetails) button.hidden = !hasDetails;
        button.setAttribute('aria-expanded', String(expanded));
        // 插件异步报价/开关及折扣重绘后，空明细入口也同步收起。
        if (panel.hidden !== !expanded) panel.hidden = !expanded;
        root.dataset.cartSummaryOpen = String(expanded);
      }
      if (fee) {
        const show = hasProtection && expanded;
        if (fee.hidden !== !show) fee.hidden = !show;
        if (show) copyMoney(cardPrice, fee.querySelector('[data-cart-summary-fee]'));
      }
      if (!observed.has(scope)) {
        observed.add(scope);
        observer.observe(scope, { childList: true, subtree: true, characterData: true,
          attributes: true, attributeFilter: ['class', 'hidden', 'data-payable-cents'] });
      }
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; render(); });
  }

  const observer = new MutationObserver(schedule);
  // 抽屉会整块替换，/cart 会原位 patch；只在实际插入/替换消费者时重新绑定。
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches('[data-cart-summary], #CartDrawer, #main-cart-footer') ||
        node.querySelector('[data-cart-summary]'))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-summary-toggle]');
    if (!button) return;
    const root = button.closest('[data-cart-summary]');
    open.set(root.dataset.cartSummary, button.getAttribute('aria-expanded') !== 'true');
    render();
  });
  document.addEventListener('cart:rendered', render);
  window.CartPresentation = { render };
  render();
})();
